import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

//@material-ui components
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tabs, Tab, Paper } from '@material-ui/core';
//Other components

import GridContainer from "components/grid/gridContainer.js";
import GridItem from "components/grid/gridItem.js";
import CustomAssetRow from 'components/customAssetRow/customAssetRow';
import CustomAssetRowBig from 'components/customAssetRow/customAssetRowBig';
import TabPanel from "components/tabPanel/tabPanel";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useAssetSectionStyles = makeStyles({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  tabsBar: {
    backgroundColor: "white",
    color: "black",
  },
  assetsType1: {
    "@media (min-width: 960px)": {
      display: "none",
    },
  },
  assetsType2: {
    "@media (max-width: 960px)": {
      display: "none",
    },
  },
  availabilityOnDemandMessage: {
    textAlign: "left",
    padding: "40px "
  },
  titleHeader: {
    paddingLeft: "40px",
    textAlign: "left",
    color: "#000",
    fontWeight: "bold"
  },
  tabSelector: {
    fontSize: "0.975rem",
    fontWeight: "bold"
  },
  customTabStyling: {
    color: "#000",
    fontSize: "0.975rem",
    fontWeight: "bold"
  }
});

/* CUSTOM TABS */
const StyledTabs = withStyles((theme) => ({
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
}))((props) => <Tabs {...props} />);

/* CUSTOM TAB */
const StyledTab = withStyles((theme) => ({
  selected: {
    color: theme.palette.primary.main
  }
}))((props) => <Tab {...props} />);

export default function AssetsSection(props) {
  const { rows } = props;
  const classes = useAssetSectionStyles();
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const countRows = (available) => {
    var count = 0;
    rows.forEach(row => {
      row.assets.forEach(asset => {
        if (asset.equipmentInUse === !available)
          count++;
      });
    });
    return count;
  };

  const anyLFOD = () => {
    for (var i = 0; i < rows.length; i++) {
      for (var j = 0; j < rows[i].assets.length; j++) {
        if (rows[i].assets[j].paramount_feature_enabled === true) {
          return true;
        }
      }
    }
    return false
  };



  return (
    <div className={classes.root}>
      <Paper square className={"step2-guidedTour"}>
        <h3 className={classes.titleHeader}>TRIP PLANNER</h3>
        <StyledTabs value={value} onChange={handleChange}
          aria-label="simple tabs"
          className={classes.tabsBar}
          centered>
          <StyledTab className={classes.customTabStyling} label={<span >{t("available")} ({countRows(true)})</span>
          } {...a11yProps(0)} />
          <StyledTab className={classes.customTabStyling} label={<span >{t("unavailable")} ({countRows(false)})</span>
          } {...a11yProps(1)} />
        </StyledTabs>
      </Paper>
      {anyLFOD() ?
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} className={classes.availabilityOnDemandMessage}>
            {t('availabilityOnDemandMessage')}
          </GridItem>
        </GridContainer>
        : null
      }
      <TabPanel value={value} index={0}>
        <GridContainer >
          <GridItem xs={12} sm={12} md={12} className={classes.assetsType1}>
            {rows.map((elem) => (
              <CustomAssetRow showAvailable={true} assets={elem.assets} type={elem.type} key={elem.type} />
            ))}
          </GridItem>
          <GridItem xs={12} sm={12} md={12} className={classes.assetsType2}>
            <CustomAssetRowBig showAvailable={true} rows={rows} />
          </GridItem>
        </GridContainer>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} className={classes.assetsType1}>
            {rows.map((elem) => (
              <CustomAssetRow showAvailable={false} assets={elem.assets} type={elem.type} key={elem.type} />
            ))}
          </GridItem>
          <GridItem xs={12} sm={12} md={12} className={classes.assetsType2}>
            <CustomAssetRowBig showAvailable={false} rows={rows} />
          </GridItem>
        </GridContainer>
      </TabPanel>
    </div>

  );
}


AssetsSection.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};